import { NamedProperty } from "sprint-common-web";

import { LanguageSpecificationLookupResponse } from "../api/orders-api/language-specification/responses/GetLanguageSpecificationsLookupResponse";

export type LanguageSpecification = NamedProperty;

export const mapToLanguageSpecification = (response: LanguageSpecificationLookupResponse): LanguageSpecification => ({
    id: response.id,
    name: response.name
});
